import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from "../../../globals";
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { SetupInital3Page } from '../setup-initial-3/setup-initial-3';
/**
 * Generated class for the SetupInitalData2Page page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-setup-initial-4',
    templateUrl: 'setup-initial-4.html',
})
export class SetupInital4Page {
    type: any = '';

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        private globals: Globals,
        public translate: TranslateService,
        private http: HttpClient,
        public toastCtrl: ToastController,) {
    }

    ionViewWillEnter() { }

    selectType(type) {
        var select = undefined;
        switch (type) {
            case 'new_open':
                select = document.getElementsByClassName('selected')[0];
                if (select) {
                    select.classList.remove('selected');
                }
                document.getElementById('new_open').classList.add('selected');
                this.type = 'new_open';
                break;
            case 'digitalise_business':
                select = document.getElementsByClassName('selected')[0];
                if (select) {
                    select.classList.remove('selected');
                }
                document.getElementById('digitalise_business').classList.add('selected');
                this.type = 'digitalise_business';
                break;
        }
    }

    saveForm() {
        if (this.type == '') {
            let toast = this.toastCtrl.create({
                message: this.translate.instant('general-selecciona-una-opcion'),
                duration: 3000,
                position: 'top'
            });
            toast.present();
        } else {
            var msg = '';
            if (this.type == 'new_open') {
                msg = 'NUEVA APERTURA DEL ESTABLECIMIENTO ' + this.globals.restaurant.email + ' - ' + this.globals.restaurant.phone;
                this.sendSlack(msg);
            } else if (this.type == 'digitalise_business') {
                msg = 'Digitalización del establecimiento ' + this.globals.restaurant.email + ' - ' + this.globals.restaurant.phone;
                this.sendSlack(msg);
            }
            this.navCtrl.push(SetupInital3Page);
        }
    }

    async sendSlack(msg) {
        await this.http.post(this.globals.api_path + 'slack/register', {
            msg: msg,
        }, {}).subscribe(async data => {
        },
            err => {
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/setup/setup-initial-4/setup-initial-4.ts